<template>
  <div id="app">
    <nav-header/>
    <router-view/>
  </div>
</template>

<script>
	import navHeader from './components/navHeader.vue'
	import store from './store/index.js'
	import { loadInitData } from '@/utils'
	
	import {
		APP_LOCAL_STORAGE_PREFIX,
		USER_DATA_LOCAL_STORAGE_KEY,
	} from '@/const'

  
  export default {
		components: { navHeader },
		async mounted() {
			const userData = localStorage.getItem(`${APP_LOCAL_STORAGE_PREFIX}_${USER_DATA_LOCAL_STORAGE_KEY}`)
			if (userData) {
				const { isLogged, refreshToken, accessToken, email } = JSON.parse(userData)
				if (isLogged) {
					store.dispatch('loadUserData', { email, refreshToken, accessToken })
					.then(async () => {
						//const tokenRefreshed = await tokenRefresh()
						//if (!tokenRefreshed) {
						//store.dispatch('logout')
						//}
					})
				}
			}
		},
		created() {
			this.unwatch = this.$store.watch(
				(state, getters) => getters.isLoggedIn,
				(newValue, oldValue) => {
					if (newValue && newValue !== oldValue) {
						console.log('WATCHER CHANGES isLoggedIn')
						this.initApp()
						this.$router.push('/home')
					} else if (!newValue && newValue !== oldValue) {
						console.log('WATCHER CHANGES not isLoggedIn')
						this.$router.push('/login')
					}
				},
			)
		},
		methods: {
			initApp() {
				loadInitData(store)
			},
		},	
  }
</script>

<style>
	html, body, #app {
		min-height: 100vh;
	}
	
	#app {
		display: flex;
		flex-direction: column;
	}
	
	.vc-material-hex {
		border-bottom-width: 8px !important;
	}

	div.modal .modal-dialog.modal-full {
  	max-width: calc(100% - 40px)!important;
	}	
</style>